export default __webpack_public_path__ + "static/media/shutterstock_676869007.8874e80c.png";